import { FC } from "react";
import { Box, Typography } from "@mui/material";
import useRegionManagementStore from "../../../state/region-management-store";
import { MapComponentProps } from "../../../components/map/map.types";
import MapProvider from "../../../components/map/map-provider";
import MapComponent from "../../../components/map/map";
import { makeSxStyles } from "ui";
import { InfoOutlined, DoneOutlined } from "@mui/icons-material";
import RegionSidebarSequence from "./region-sidebar-sequence";

const RegionSequenceModal: FC = () => {
  const {
    selectedAddressesForSequencing,
    remainingSequences,
    allSequenced,
    mapZoom,
    sidebar,
    lastSequence,
    setQuery,
    setSelectedAddress,
    setMapZoom,
    toggleDrawing,
    setSidebar,
    setAddressSequence,
  } = useRegionManagementStore();

  const styles = useStyles();

  const mapProps: MapComponentProps = {
    mapWidth: "100%",
    mapHeight: "65vh",
    markers: selectedAddressesForSequencing,
    mapZoom,
    showTopMapControl: false,
    selectedAddresses: selectedAddressesForSequencing,
    isLoading: false,
    isSearchLoading: false,
    sequencing: true,
    sequencingUnassigned: true,
    lastSequence: lastSequence,
    setQuery: setQuery,
    setSelectedAddress: setSelectedAddress,
    onMapZoomChange: setMapZoom,
    onDrawingToggle: toggleDrawing,
    setAddressSequence: setAddressSequence,
    setSidebar,
  };

  return (
    <Box sx={styles.container}>
      <Box sx={sidebar ? styles.hasSidebar : styles.noSidebar}>
        <MapProvider>
          <MapComponent {...mapProps} />
        </MapProvider>
      </Box>

      {sidebar && (
        <RegionSidebarSequence
          customHeader={
            <Box sx={styles.sideBarTitleInfo}>
              <Typography>
                Sequence addresses by clicking on each address on the map,
                starting with the first and ending with the last.
              </Typography>
              <Box sx={styles.infoBar}>
                {!allSequenced ? (
                  <>
                    <InfoOutlined
                      style={{ marginRight: "8px", color: "#8ACEFF" }}
                    />
                    <Typography>
                      {remainingSequences === 0
                        ? selectedAddressesForSequencing &&
                          selectedAddressesForSequencing.length
                        : remainingSequences}{" "}
                      addresses to be sequenced.
                    </Typography>
                  </>
                ) : (
                  <>
                    <DoneOutlined
                      style={{
                        marginRight: "8px",
                        color: "rgba(63, 191, 158, 1)",
                      }}
                    />
                    <Typography sx={{ fontSize: "13px" }}>
                      Sequence is ready to be confirmed.
                    </Typography>
                  </>
                )}
              </Box>
            </Box>
          }
        />
      )}
    </Box>
  );
};

const useStyles = makeSxStyles(() => ({
  container: {
    display: "flex",
    width: "100%",
    height: "65vh",
    minHeight: "500px",
  },
  hasSidebar: {
    width: "calc(100% - 340px)",
  },
  noSidebar: {
    width: "100%",
  },
  sideBarTitleInfo: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    justifyContent: "space-between",
    paddingBottom: "15px",
    borderBottom: "1px solid rgba(65, 71, 77, 1)",
  },
  infoBar: {
    display: "flex",
    flexDirection: "row",
    marginTop: "12px",
    alignItems: "center",
  },
}));

export default RegionSequenceModal;
